
export default {
  name: "CorrecaoFiscalItemCarrinho",

  props: {
    visivel: { type: Boolean, default: false },
    /** Item do carrinho (in-memory) */
    item:    { type: Object, default: null },
    /** Resultado de parseErroFiscalProduto – pode ser null para abertura manual */
    erroInfo: { type: Object, default: null },
  },

  emits: ["fechar", "salvar"],

  data() {
    return {
      form: {
        ncm:        "",
        cfop:       "",
        csosn:      "102",
        cst_icms:   "",
        origem:     "0",
        cst_pis:    "07",
        cst_cofins: "07",
      },
      erros: {
        ncm:   null,
        cfop:  null,
        csosn: null,
      },
      erroGeral: null,
    };
  },

  watch: {
    // Preenche formulário sempre que o item mudar
    item: {
      immediate: true,
      handler(novo) {
        if (!novo) return;
        this._preencherFormComItem(novo);
      },
    },

    visivel(val) {
      if (val) {
        this.erroGeral = null;
        this.erros = { ncm: null, cfop: null, csosn: null };
        this.$nextTick(() => {
          this.$refs.ncmInput && this.$refs.ncmInput.focus();
        });
      }
    },
  },

  methods: {
    fmtBRL(v) {
      return Number(v || 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    _preencherFormComItem(item) {
      const orig = item.produto_original || {};

      // Lê dados fiscais do item ou do produto original
      let payloadFiscal = {};
      try {
        const p = item.payload_json ? JSON.parse(item.payload_json) : {};
        const prod = p.produto || p;
        payloadFiscal = prod.fiscal || prod._fiscal || prod.dados_fiscais || prod;
      } catch (_) { /* ignore */ }

      this.form.ncm   = item.ncm_codigo   || orig.ncm_codigo   || payloadFiscal.ncm   || "";
      this.form.cfop  = item.cfop_codigo  || orig.cfop_codigo  || payloadFiscal.cfop  || payloadFiscal.cfop_nfce || "";

      // CSOSN – produto pode ter cst_csosn_codigo (simples) ou contribuinte (normal)
      this.form.csosn    = item.cst_csosn_codigo              || orig.cst_csosn_codigo              || payloadFiscal.csosn || "102";
      this.form.cst_icms = item.cst_csosn_contribuinte_codigo || orig.cst_csosn_contribuinte_codigo || payloadFiscal.cst   || "";
      this.form.origem   = String(payloadFiscal.orig ?? orig.origem_mercadoria ?? "0");

      this.form.cst_pis    = item.cst_pis_codigo    || orig.cst_pis_codigo    || payloadFiscal.cst_pis    || "07";
      this.form.cst_cofins = item.cst_cofins_codigo || orig.cst_cofins_codigo || payloadFiscal.cst_cofins || "07";
    },

    _validar() {
      let ok = true;
      this.erros = { ncm: null, cfop: null, csosn: null };
      this.erroGeral = null;

      // NCM: obrigatório, 8 dígitos numéricos
      const ncmLimpo = String(this.form.ncm || "").replace(/\D/g, "");
      if (!ncmLimpo) {
        this.erros.ncm = "NCM é obrigatório.";
        ok = false;
      } else if (ncmLimpo.length !== 8) {
        this.erros.ncm = `NCM deve ter 8 dígitos (informado: ${ncmLimpo.length}).`;
        ok = false;
      }

      // CFOP: obrigatório, 4 dígitos
      const cfopLimpo = String(this.form.cfop || "").replace(/\D/g, "");
      if (!cfopLimpo) {
        this.erros.cfop = "CFOP é obrigatório.";
        ok = false;
      } else if (cfopLimpo.length !== 4) {
        this.erros.cfop = `CFOP deve ter 4 dígitos (informado: ${cfopLimpo.length}).`;
        ok = false;
      }

      // CSOSN/CST: ao menos um preenchido
      if (!this.form.csosn && !this.form.cst_icms) {
        this.erros.csosn = "Informe o CSOSN (Simples Nacional) ou o CST ICMS (Regime Normal).";
        ok = false;
      }

      return ok;
    },

    salvar() {
      if (!this._validar()) return;

      const ncmLimpo  = String(this.form.ncm  || "").replace(/\D/g, "");
      const cfopLimpo = String(this.form.cfop || "").replace(/\D/g, "");

      this.$emit("salvar", {
        ncm:        ncmLimpo,
        cfop:       cfopLimpo,
        csosn:      this.form.csosn    || null,
        cst_icms:   this.form.cst_icms || null,
        origem:     this.form.origem   || "0",
        cst_pis:    this.form.cst_pis    || "07",
        cst_cofins: this.form.cst_cofins || "07",
      });
    },
  },
};
